function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M256,121c-74.399,0-135,60.599-135,135c0,74.399,60.601,135,135,135s135-60.601,135-135     C391,181.599,330.399,121,256,121z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M271,15v60c0,8.399-6.599,15-15,15s-15-6.601-15-15V15c0-8.401,6.599-15,15-15S271,6.599,271,15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M271,437v60c0,8.399-6.599,15-15,15s-15-6.601-15-15v-60c0-8.401,6.599-15,15-15     S271,428.599,271,437z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M173.266,95.438l-11.484-27.715c-3.164-7.646,0.469-16.436,8.115-19.6     c7.632-3.105,16.436,0.454,19.6,8.115l11.484,27.715c3.164,7.646-0.469,16.436-8.115,19.6     C185.238,106.712,176.434,103.098,173.266,95.438z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M322.504,455.761l-11.484-27.715c-3.164-7.646,0.469-16.436,8.115-19.6     c7.646-3.12,16.436,0.454,19.6,8.115l11.484,27.715c3.164,7.646-0.469,16.436-8.115,19.6     C334.477,467.034,325.673,463.42,322.504,455.761z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M324.877,104.696c-1.919,0-3.867-0.366-5.742-1.143c-7.646-3.164-11.279-11.953-8.115-19.6     l11.484-27.715c3.179-7.661,11.997-11.235,19.6-8.115c7.646,3.164,11.279,11.953,8.115,19.6l-11.484,27.715     C336.347,101.21,330.751,104.696,324.877,104.696z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M169.896,463.876c-7.646-3.164-11.279-11.953-8.115-19.6l11.484-27.715     c3.164-7.661,11.982-11.25,19.6-8.115c7.646,3.164,11.279,11.953,8.115,19.6l-11.484,27.715     C186.327,463.42,177.523,467.034,169.896,463.876z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M75,271H15c-8.291,0-15-6.709-15-15s6.709-15,15-15h60c8.291,0,15,6.709,15,15S83.291,271,75,271z     "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M497,271h-60c-8.291,0-15-6.709-15-15s6.709-15,15-15h60c8.291,0,15,6.709,15,15     S505.291,271,497,271z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M118.114,139.325L75.692,96.903c-5.859-5.859-5.859-15.352,0-21.211s15.352-5.859,21.211,0     l42.422,42.422c5.859,5.859,5.859,15.352,0,21.211C133.466,145.185,123.974,145.185,118.114,139.325z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M415.097,436.308l-42.422-42.422c-5.859-5.859-5.859-15.352,0-21.211s15.352-5.859,21.211,0     l42.422,42.422c5.859,5.859,5.859,15.352,0,21.211C430.448,442.167,420.956,442.167,415.097,436.308z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M75.692,436.308c-5.859-5.859-5.859-15.352,0-21.211l42.422-42.422     c5.859-5.859,15.352-5.859,21.211,0s5.859,15.352,0,21.211l-42.422,42.422C91.044,442.167,81.552,442.167,75.692,436.308z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M372.675,139.325c-5.859-5.859-5.859-15.352,0-21.211l42.422-42.422     c5.859-5.859,15.352-5.859,21.211,0s5.859,15.352,0,21.211l-42.422,42.422C388.026,145.185,378.534,145.185,372.675,139.325z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M61.981,351.361c-5.874,0-11.47-3.486-13.857-9.258c-3.164-7.646,0.469-16.436,8.115-19.6     l27.715-11.484c7.617-3.135,16.45,0.469,19.6,8.115c3.164,7.646-0.469,16.436-8.115,19.6l-27.715,11.484     C65.849,350.995,63.9,351.361,61.981,351.361z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M408.446,192.865c-3.164-7.646,0.469-16.436,8.115-19.6l27.715-11.484     c7.617-3.149,16.421,0.469,19.6,8.115c3.164,7.646-0.469,16.436-8.115,19.6l-27.715,11.484     C420.419,204.138,411.615,200.524,408.446,192.865z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M444.276,350.219l-27.715-11.484c-7.646-3.164-11.279-11.953-8.115-19.6s11.968-11.265,19.6-8.115     l27.715,11.484c7.646,3.164,11.279,11.953,8.115,19.6C460.707,349.763,451.903,353.377,444.276,350.219z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M83.954,200.98l-27.715-11.484c-7.646-3.164-11.279-11.953-8.115-19.6     c3.164-7.661,11.968-11.279,19.6-8.115l27.715,11.484c7.646,3.164,11.279,11.953,8.115,19.6     C100.385,200.524,91.581,204.138,83.954,200.98z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M256,90V0c8.401,0,15,6.599,15,15v60C271,83.399,264.401,90,256,90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M271,437v60c0,8.399-6.599,15-15,15v-90C264.401,422,271,428.599,271,437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M391,256c0,74.399-60.601,135-135,135V121C330.399,121,391,181.599,391,256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.dc38b60647125eb94b7abbeb930f73ea.svg";
export { ForwardRef as ReactComponent };